var render = function render() {
  var _vm$userInfo$external, _vm$userInfo$external2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "galleryViewBox",
    staticClass: "galleryBox"
  }, [_c('div', {
    class: _vm.headLayoutClass,
    attrs: {
      "id": "galleryModule"
    }
  }, [_c('header', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "header-left left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('galleryHost.output')) + ":")]), _c('el-select', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.scroll,
      expression: "scroll"
    }],
    staticClass: "selectBox m_r_20",
    attrs: {
      "visible-arrow": false,
      "placeholder": _vm.$t('galleryHost.outputPlaceholder'),
      "no-data-text": "No Data",
      "no-match-text": "No Data",
      "popper-class": "pullStreamDrop",
      "remote-method": _vm.searchPullStreamList,
      "filterable": "",
      "remote": ""
    },
    on: {
      "change": _vm.savePullRId,
      "visible-change": _vm.getPullStreamList
    },
    model: {
      value: _vm.pullStreamObj.rid,
      callback: function ($$v) {
        _vm.$set(_vm.pullStreamObj, "rid", $$v);
      },
      expression: "pullStreamObj.rid"
    }
  }, _vm._l(_vm.pullStreamObj.rList, function (item) {
    return _c('el-option', {
      key: item.peerId,
      class: _vm.returnColor(item, 'pullStream'),
      attrs: {
        "label": item.name,
        "value": item.peerId
      }
    });
  }), 1), _c('i', {
    staticClass: "iconfont icon-Outputsetting",
    on: {
      "click": _vm.showNamePopup
    }
  }), _c('el-divider', {
    staticClass: "nameDivider",
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-button', {
    class: _vm.returnClass(_vm.pullStreamObj.status, 'pullStream'),
    attrs: {
      "disabled": !this.pullStreamObj.rid
    },
    on: {
      "click": _vm.setPartyOutput
    }
  }, [_vm._v(" " + _vm._s(_vm.pullStreamObj.text === 'Send' ? _vm.$t('galleryHost.send') : _vm.$t('galleryHost.stop'))), _vm.pullLoading ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()])], 1), _vm.userInfo.rtilCode ? _c('MainWindowSelect', {
    ref: "mainWindowSelect",
    attrs: {
      "partyCode": _vm.groupPartyCode,
      "shareRtilCode": _vm.shareRtilCode,
      "currentTypeShare": "mainWindow",
      "partyInfo": _vm.userInfo,
      "shareList": _vm.shareList,
      "pageNum": _vm.sendParmas.pageNum,
      "nickNameInfo": _vm.behaviorInfo,
      "muteVideoObj": !_vm.State.cameraStatus,
      "mainWindowList": _vm.mainWindowList,
      "rtilCodeList": _vm.rtilCodeList
    },
    on: {
      "callback": _vm.mainwindowSelectCallback
    },
    scopedSlots: _vm._u([{
      key: "galleryPreviewBox",
      fn: function () {
        return [_c('el-popover', {
          attrs: {
            "placement": "bottom",
            "width": "340",
            "popper-class": _vm.returnPreviewClass,
            "trigger": "click"
          },
          model: {
            value: _vm.previewVisible,
            callback: function ($$v) {
              _vm.previewVisible = $$v;
            },
            expression: "previewVisible"
          }
        }, [_c('div', {
          staticClass: "content-box"
        }, [_c('div', {
          staticClass: "content-head"
        }, [_vm._v(_vm._s(_vm.$t('conferenceHost.mainWindow')) + ":")]), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.showOutputBtn,
            expression: "showOutputBtn"
          }],
          staticClass: "outputText ellipsis",
          attrs: {
            "title": _vm.selectMainWindow
          }
        }, [_vm._v(_vm._s(_vm.selectMainWindow))]), _vm.vfbVideoInfo ? _c('div', {
          staticClass: "vfbVideoBox"
        }, [_c('NewAttendUser', {
          ref: "mainwindowBox",
          class: {
            notShowFootBar: !_vm.State.showFootBar
          },
          attrs: {
            "nickName": _vm.behaviorInfo[_vm.vfbVideoInfo.id] || '',
            "tagName": _vm.tagNameInfo[_vm.vfbVideoInfo.id],
            "singChannel": _vm.vfbVideoInfo,
            "userInfo": _vm.userInfo,
            "title": _vm.returnTitle,
            "degreeHost": _vm.degreeHost[_vm.vfbVideoInfo.id],
            "outputRtilCode": _vm.outputRtilCode + '',
            "theme": "danger",
            "volume": _vm.voiceList[_vm.vfbVideoInfo.id],
            "showMuteIcons": false,
            "notShowPraviteBg": true,
            "showOperateBox": false,
            "isMute": _vm.State.isMute,
            "useOldFullScreen": true,
            "rtc": _vm.rtc[_vm.userInfo.externalJoinInfo.join],
            "muteVideo": !_vm.State.cameraStatus[_vm.vfbVideoInfo.id],
            "muteAudio": !_vm.State.micStatus[_vm.vfbVideoInfo.id],
            "isAudioLevel": _vm.audioLevel
          },
          on: {
            "callback": _vm.attendCallback
          }
        })], 1) : _vm._e(), _vm.State.galleryBroadcastInfo ? _c('p', {
          staticClass: "grayColor"
        }, [_vm._v(_vm._s(_vm.$t('galleryHost.broadcasterTips')))]) : _vm._e()]), _vm.State.gallerySpeakerInfo ? _c('div', {
          staticClass: "content-head"
        }, [_vm._v(_vm._s(_vm.$t('galleryHost.publicSpeaker')))]) : _vm._e(), _vm.State.gallerySpeakerInfo ? _c('div', {
          staticClass: "speakerBox"
        }, [_c('span', [_vm._v(_vm._s(_vm.State.gallerySpeakerInfo ? _vm.State.gallerySpeakerInfo.nickName : ''))]), _c('span', {
          staticClass: "stopBtn",
          on: {
            "click": _vm.cancelSpeaker
          }
        }, [_vm._v(_vm._s(_vm.$t('audioChannels.stop')))])]) : _vm._e(), _c('div', {
          staticClass: "redSpotsBox pointer",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.$route.name == 'group',
            expression: "$route.name == 'group'"
          }],
          staticClass: "iconfont icon-show pointer"
        })])])];
      },
      proxy: true
    }], null, false, 2603569526)
  }) : _vm._e()], 1), _c('main', {
    staticClass: "videoBoxDiv"
  }, [_c('div', {
    staticClass: "video-placeholder",
    attrs: {
      "id": "share_stream"
    }
  }), _vm._l(_vm.partyCodeList, function (val, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: false,
        expression: "false"
      }],
      key: key,
      staticStyle: {
        "width": "200px",
        "height": "200px",
        "display": "inline-block"
      }
    }, [_c('NewAttendUser', {
      staticClass: "is-local",
      class: {
        notShowFootBar: !_vm.State.showFootBar
      },
      attrs: {
        "title": "Me",
        "singChannel": _vm.meInfo,
        "userInfo": _vm.userInfo,
        "isAudioLevel": _vm.audioLevel
      },
      on: {
        "callback": _vm.attendCallback
      }
    }, [_c('div', {
      staticClass: "localVideo",
      attrs: {
        "id": `local_stream${val}`
      }
    }), _c('div', {
      staticClass: "video-placeholder",
      attrs: {
        "id": `share_stream${val}`
      }
    })])], 1);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticStyle: {
      "width": "200px",
      "height": "200px",
      "display": "inline-block"
    }
  }, [_c('NewAttendUser', {
    staticClass: "is-local",
    attrs: {
      "title": "extral-me"
    }
  }, [_c('div', {
    staticClass: "localVideo",
    attrs: {
      "id": "sendVideo"
    }
  })])], 1), _c('div', {
    staticClass: "pipList",
    class: {
      fullScreen: _vm.pipsListFullScreen
    }
  }, [_c('div', {
    staticClass: "closeBtn",
    on: {
      "mouseenter": function ($event) {
        return _vm.showFullScreenCloseBtnFn(true);
      },
      "mouseleave": function ($event) {
        return _vm.showFullScreenCloseBtnFn(false);
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showCloseFullScreenBtn,
      expression: "showCloseFullScreenBtn"
    }],
    on: {
      "click": function ($event) {
        _vm.pipsListFullScreen = false;
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-error"
  }), _vm._v(_vm._s(_vm.$t('galleryHost.exitFullScreen')))])]), _c('div', {
    staticClass: "pipContent clearfix",
    class: _vm.headLayoutClass
  }, _vm._l(_vm.rtilCodeList, function (rtilCode, index) {
    var _vm$State$imagePositi;
    return _c('div', {
      key: rtilCode,
      staticClass: "containers",
      class: _vm.layoutClass(rtilCode, index)
    }, [_vm.State.batchMoveParticipate && rtilCode > 0 && (_vm.rtilCodeKeyTypeVal[rtilCode] == 'Web' || _vm.rtilCodeKeyTypeVal[rtilCode] == 'Anywhere' || _vm.rtilCodeKeyTypeVal[rtilCode] == 'App') ? _c('div', {
      staticClass: "checkBox"
    }, [_c('el-checkbox', {
      on: {
        "change": val => {
          _vm.moveParty(val, rtilCode);
        }
      },
      model: {
        value: _vm.movePips[rtilCode],
        callback: function ($$v) {
          _vm.$set(_vm.movePips, rtilCode, $$v);
        },
        expression: "movePips[rtilCode]"
      }
    })], 1) : _vm._e(), (_vm.channels[rtilCode] && !_vm.channels[rtilCode].leave ? _vm.State.groupLayout.layoutName === '6-24-80-80' ? _vm.videoIndex ? index > 71 : index < 72 : true : '') ? _c('NewAttendUser', {
      key: rtilCode,
      ref: `remoteSource${rtilCode}`,
      refInFor: true,
      staticClass: "gallery",
      class: _vm.returnSmallClass,
      attrs: {
        "volume": _vm.voiceList[rtilCode],
        "degreeHost": _vm.degreeHost[rtilCode],
        "title": _vm.channels[rtilCode] ? _vm.channels[rtilCode].tid : '',
        "nickName": _vm.behaviorInfo[rtilCode] || (_vm.channels[rtilCode] ? _vm.channels[rtilCode].tid : ''),
        "tagName": _vm.tagNameInfo[rtilCode],
        "singChannel": _vm.channels[rtilCode],
        "anywherePopShow": _vm.anywhereSettingShowMap[rtilCode],
        "isShare": false,
        "outputRtilCode": _vm.outputRtilCode + '',
        "muteVideo": !_vm.State.cameraStatus[rtilCode],
        "muteAudio": !_vm.State.micStatus[rtilCode],
        "userInfo": _vm.userInfo,
        "sourceType": _vm.rtilCodeKeyTypeVal[rtilCode],
        "showTitle": _vm.State.groupLayout.layoutName != '7-7-80-80' && _vm.State.groupLayout.layoutName != '12-24-80-80' && _vm.State.groupLayout.layoutName != '6-24-80-80',
        "operateList": _vm.operateList[rtilCode],
        "liveInfo": _vm.rtilStatusObj[rtilCode] || {},
        "asRoleList": _vm.returnRoleList(rtilCode),
        "currentRole": _vm.returnRole(rtilCode),
        "rtc": _vm.rtcByRtilCode[rtilCode],
        "isAudioLevel": _vm.audioLevel,
        "controlMute": _vm.controlMutes[rtilCode],
        "showMuteIcons": !_vm.pipsListFullScreen && !_vm.channels[rtilCode].leave,
        "remoteNetWorks": _vm.remoteNetWorks[rtilCode],
        "editNickName": _vm.pipsListFullScreen ? false : true
      },
      on: {
        "callback": _vm.attendCallback
      },
      scopedSlots: _vm._u([_vm.channels[rtilCode] && _vm.showRListWithLive ? {
        key: "videoBottom",
        fn: function () {
          return [_c('div', {
            staticClass: "rList"
          }, [_c('liveSourceSelect', {
            ref: `liveSource${rtilCode}`,
            refInFor: true,
            attrs: {
              "allRList": _vm.allRList,
              "partyCode": _vm.channels[rtilCode].channel,
              "nickName": _vm.behaviorInfo[rtilCode],
              "rtilCode": rtilCode,
              "useNewUi": true,
              "memberId": _vm.channels[rtilCode].tid,
              "liveInfo": _vm.rtilStatusObj[rtilCode] || {}
            },
            on: {
              "callback": _vm.callbackByLiveSource
            }
          })], 1)];
        },
        proxy: true
      } : null], null, true)
    }, [_vm.State.gallerySpeakerInfo && _vm.State.gallerySpeakerInfo.rtilCode == rtilCode ? _c('div', {
      staticClass: "speakerBox"
    }, [_vm._v("SPEAKER")]) : _vm._e()]) : _c('div', {
      staticClass: "position"
    }, [_vm.onlyShowLastFrame(rtilCode) ? _c('div', {
      staticClass: "lastFrame"
    }, [_vm._v(_vm._s(_vm.$t('common.lastFrame')))]) : _vm._e(), _vm.showCopyText(rtilCode, index) ? _c('div', {
      staticClass: "lastFrame"
    }, [_c('div', [_vm._v(_vm._s(_vm.$t('common.empty')))]), _vm._v(_vm._s(_vm.$t('common.copySlot', {
      index: _vm.slotIndex
    })))]) : _vm._e(), _vm.showImage(index) ? _c('div', {
      staticClass: "uploadImage"
    }, [_c('div', {
      staticClass: "contentBox"
    }, [_c('div', {
      staticClass: "content"
    }, [_vm.State.uploadingImageInfo[index] ? _c('el-progress', {
      attrs: {
        "type": "circle",
        "color": "#33AB4F",
        "percentage": _vm.State.uploadImagePercent[index]
      }
    }) : _c('img', {
      class: _vm.imageClass(index),
      attrs: {
        "src": (_vm$State$imagePositi = _vm.State.imagePositionInfo[index]) === null || _vm$State$imagePositi === void 0 ? void 0 : _vm$State$imagePositi.imageUrl
      }
    })], 1)])]) : _vm._e(), _vm.showLogo(rtilCode, index) ? _c('div', {
      staticClass: "logoBox"
    }, [_c('img', {
      staticClass: "tvuLogo",
      attrs: {
        "src": _vm.logoGray
      }
    }), _c('p', [_vm._v(_vm._s(_vm.$t('mainWindow.noSource')))])]) : _vm._e(), !_vm.pipsListFullScreen ? _c('operate-button', {
      attrs: {
        "btnList": _vm.returnButtonList(rtilCode, index),
        "userInfo": _vm.userInfo,
        "slotIndex": index,
        "singChannel": _vm.channels[rtilCode]
      },
      on: {
        "callback": obj => {
          _vm.attendCallback({
            ...obj,
            index
          });
        }
      }
    }) : _vm._e()], 1)], 1);
  }), 0)])], 2), _vm.showLeft ? _c('div', {
    staticClass: "lastPage",
    class: _vm.enableLast,
    on: {
      "click": function ($event) {
        return _vm.loadVideo($event, 'last');
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-back"
  })]) : _vm._e(), _c('div', {
    staticClass: "pageNumLeft"
  }, [_vm._v(" " + _vm._s(_vm.sendParmas.pageNum) + " ")]), _vm.showNextPageIcon ? _c('div', {
    staticClass: "nextIcon",
    on: {
      "click": function ($event) {
        return _vm.loadVideo($event, 'next');
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-right"
  })]) : _vm._e(), _c('div', {
    staticClass: "pageNumRight"
  }, [_vm._v(" " + _vm._s(_vm.sendParmas.pageNum) + " ")]), _vm.uploadImageInfo.visible ? _c('uploadImage', {
    attrs: {
      "drawerInfo": _vm.uploadImageInfo,
      "userInfo": _vm.userInfo
    },
    on: {
      "callback": _vm.uploadImageCallback
    }
  }) : _vm._e()], 1), _c('guide-page', {
    attrs: {
      "dialogVisible": _vm.State.guideObjShow
    }
  }), _c('tipsDailog', {
    attrs: {
      "width": "442px",
      "info": _vm.nameInfo,
      "cancel": _vm.setNameDefault,
      "save": _vm.setNameOperation
    }
  }, [_c('div', {
    staticClass: "nameBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('galleryHost.nameOperationCon')))]), _c('el-switch', {
    staticClass: "right",
    attrs: {
      "active-color": "#33ab4f",
      "inactive-color": "#9f9f9f"
    },
    model: {
      value: _vm.nameCheck,
      callback: function ($$v) {
        _vm.nameCheck = $$v;
      },
      expression: "nameCheck"
    }
  })], 1), _c('div', {
    staticClass: "fontNameBox",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', {
    staticClass: "m_r_10"
  }, [_vm._v(_vm._s(_vm.$t('galleryHost.fontName')))]), _c('el-select', {
    staticClass: "grayStyle",
    attrs: {
      "popper-class": "whiteStyle",
      "placeholder": _vm.$t('galleryHost.fontNamePlaceholder')
    },
    model: {
      value: _vm.selectFontName,
      callback: function ($$v) {
        _vm.selectFontName = $$v;
      },
      expression: "selectFontName"
    }
  }, _vm._l(_vm.fontName, function (item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    });
  }), 1)], 1)]), _vm.setTagName.show ? _c('tag-name', {
    attrs: {
      "info": _vm.setTagName
    },
    on: {
      "saveTagName": _vm.saveTagName
    }
  }) : _vm._e(), _vm.replaceInfo.show ? _c('replace', {
    attrs: {
      "info": _vm.replaceInfo,
      "rtilCodeList": _vm.rtilCodeList,
      "pageNumber": _vm.sendParmas.pageNum
    }
  }) : _vm._e(), _vm.movePartyInfo.show ? _c('MovePartyList', {
    attrs: {
      "info": _vm.movePartyInfo,
      "userInfo": _vm.userInfo
    }
  }) : _vm._e(), _vm.batchMovePartyInfo.show ? _c('MovePartyTips', {
    attrs: {
      "info": _vm.batchMovePartyInfo,
      "userInfo": _vm.userInfo
    }
  }) : _vm._e(), _vm.userInfo.rtilCode && _vm.loadChatBox ? _c('div', {
    staticClass: "chatBox"
  }, [_c('ChatMessage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.State.showChatMessage,
      expression: "State.showChatMessage"
    }],
    attrs: {
      "userInfo": _vm.userInfo,
      "allPartyMembers": _vm.allPartyMembers,
      "chatPartyCode": (_vm$userInfo$external = _vm.userInfo.externalJoinInfo) === null || _vm$userInfo$external === void 0 ? void 0 : _vm$userInfo$external.join,
      "showComponent": _vm.State.showChatMessage,
      "nickNameInfo": _vm.behaviorInfo,
      "tagNameInfo": _vm.tagNameInfo
    },
    on: {
      "callback": _vm.chatCallback
    }
  })], 1) : _vm._e(), _c('EncoderInfo', {
    attrs: {
      "info": _vm.encoderInfo
    }
  }), _c('Foot', {
    ref: "footDiv",
    attrs: {
      "isShare": _vm.isShare,
      "showUnread": _vm.showUnread,
      "mic": _vm.State.micStatus[_vm.userInfo.rtilCode],
      "rtcLoaded": _vm.rtcLoaded,
      "showIconArray": ['mic', 'speaker', 'share', 'chat'],
      "devicesInfo": _vm.devicesInfo,
      "isHost": true,
      "showChat": _vm.State.showChatMessage,
      "userInfo": _vm.userInfo,
      "localVolume": _vm.localVolume,
      "rtc": _vm.rtc[_vm.chatParty],
      "speakerDevice": _vm.devicesInfo.speakerList,
      "microphoneDevice": _vm.devicesInfo.microphoneList
    },
    on: {
      "eventCallback": _vm.dealFootEvent
    }
  }), _vm.anyWhereInfo.show ? _c('anywhereSetting', {
    attrs: {
      "anyWhereSetObj": _vm.anyWhereSettings[_vm.anyWhereInfo.rtilCode],
      "degreeHost": _vm.degreeHost[_vm.anyWhereInfo.rtilCode],
      "peerId": _vm.anyWherePeerIds[_vm.anyWhereInfo.rtilCode],
      "platForm": _vm.anyWherePlatForms[_vm.anyWhereInfo.rtilCode],
      "singChannel": _vm.vfbVideoInfo,
      "userInfo": _vm.userInfo,
      "info": _vm.anyWhereInfo,
      "partyCode": _vm.groupPartyCode,
      "muteAudio": !_vm.State.micStatus[_vm.anyWhereInfo.rtilCode],
      "rtc": _vm.rtc[(_vm$userInfo$external2 = _vm.userInfo.externalJoinInfo) === null || _vm$userInfo$external2 === void 0 ? void 0 : _vm$userInfo$external2.join]
    },
    on: {
      "closeAnywherePreview": _vm.closeAnywherePreview
    }
  }) : _vm._e(), _vm.drawer ? _c('addPackReceiverJoin', {
    attrs: {
      "drawer": _vm.drawer,
      "partyCode": _vm.State.partyCode,
      "userInfo": _vm.userInfo,
      "channels": _vm.channels
    },
    on: {
      "close": function ($event) {
        _vm.drawer = false;
      }
    }
  }) : _vm._e(), _vm.tipsInfo.show ? _c('TipsDailog', {
    attrs: {
      "info": _vm.tipsInfo,
      "showClose": false
    },
    on: {
      "save": _vm.startPullStream,
      "cancel": function ($event) {
        _vm.pullLoading = false;
      }
    }
  }) : _vm._e(), _vm.dailogInfo.show ? _c('TipsDailog', {
    attrs: {
      "width": "500px",
      "info": _vm.dailogInfo
    },
    on: {
      "save": _vm.sendShareScreen
    }
  }, [_c('p', {
    staticClass: "diaText"
  }, [_vm._v(_vm._s(_vm.$t('addWords.vfbSwitchToShare')))])]) : _vm._e(), _c('tipsDailog', {
    staticClass: "collaboratePopup",
    attrs: {
      "info": _vm.collaborateInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlInvite(true);
      },
      "cancel": function ($event) {
        return _vm.controlInvite(false);
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('img', {
    attrs: {
      "src": "https://dl.tvunetworks.com/static/partyline/image/people.png"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('personalInfo.account')) + " " + _vm._s(_vm.collaborateInfo.info.fromEmail) + " " + _vm._s(_vm.$t('personalInfo.collaboratePopupLike')))])]), _c('div', {
    staticClass: "popupContent"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupAllow')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail1')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail2')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail3')))])])])]), _c('tipsDailog', {
    staticClass: "repeatJoin",
    attrs: {
      "width": "550px",
      "info": _vm.repeatInfo
    },
    on: {
      "save": function ($event) {
        _vm.repeatInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.repeatContent')))])])]), _c('tipsDailog', {
    staticClass: "deviceDetail",
    attrs: {
      "info": _vm.deviceDetailInfo,
      "width": "640px"
    }
  }, [_c('deviceDetail', {
    attrs: {
      "detail": _vm.detailObj,
      "partyCode": _vm.State.partyCode,
      "deviceDetailInfo": _vm.deviceDetailInfo
    }
  })], 1), _c('tipsDailog', {
    staticClass: "micMuted",
    attrs: {
      "info": _vm.showMicMutedInfo,
      "width": "560px"
    }
  }, [_c('div', {
    staticClass: "micMutedContent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('micMutedInfo.contentTitle')))]), _c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.$t('micMutedInfo.contentMessage')))]), _c('span', {
    staticClass: "openMicBtn",
    on: {
      "click": _vm.openMicMuted
    }
  }, [_vm._v(_vm._s(_vm.$t('micMutedInfo.openBtnMes')))])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };